(function () {
  // Third-party apps that add to cart with their own button (e.g. the Rez
  // Preorder "Buy Now" button, which replaces the theme's native add-to-cart
  // button on preorder variants) don't know this theme's cart drawer exists,
  // so they never call its renderContents()/open(). Most of them do dispatch
  // a generic `cart:updated` document event after a successful add (Rez's
  // rez-preorder.js does: document.dispatchEvent(new CustomEvent('cart:updated'))),
  // so listen for that convention and drive the drawer ourselves, reusing the
  // exact same rendering path the theme's own add-to-cart flow uses.
  document.addEventListener('cart:updated', function () {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // The drawer is server-rendered with `is-empty` when the cart was empty on
    // page load. renderContents() only clears it from `.drawer__inner`, so the
    // host element keeps it — which hides the freshly rendered items (see
    // component-cart-drawer.css) and makes open() trap focus on a
    // `.drawer__inner-empty` that no longer exists. product-form.js does the
    // same removal before its own renderContents() call.
    cartDrawer.classList.remove('is-empty');

    fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => cartDrawer.renderContents({ id: null, sections: sections }))
      .catch((error) => console.error(error));
  });
})();
